import { createI18n } from 'vue-i18n'
import message from './index.js'

const localeData = {
  legacy: false, // composition API
  globalInjection: true,
  locale: localStorage.getItem('lang') || 'zhCN',
  messages: message,
}
const i18n = createI18n(localeData)

export default i18n
